(function (fb) {
    // =========================================================================
    // WAVES
    // =========================================================================

    // internal waves class
    var className = 'waves-effect';
    fb
        // For .btn classes
        .directive('btn', function () {
            return { restrict: 'C', link: linkFunction };
        })
        //Wave buttons for .btn-wave class
        .directive('btnWave', function () {
            return { restrict: 'C', link: linkFunction };
        });

    function linkFunction(scope, element, attributes) {
        scope.$watch(attributes.btnWaveDisabled, function (val) {
            if (val === undefined) {
                return;
            }

            var hasClass = element.hasClass(className);
            if (val && hasClass) {
                element.removeClass(className);
            } else if (!val && !hasClass) {
                element.addClass(className);
            }
        });
        Waves.attach(element);
        Waves.init();
    }
})(firebird);
